<!-- <h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary" *ngIf="state == 'notfound'">{{ content.header }}</h2>
<h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary" *ngIf="state != 'notfound'">{{ content.header }}</h2> -->
@if (!showTextDefault() && !showTextRedirectPort()) {
  <div class="fullscreen"></div>
}
@if (showTextDefault()) {
  <div>
    @if (content().header) {
      <h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary">
        {{ content().header }}
      </h2>
    }
    @for (body of content().body; track body) {
      <div class="uk-flex uk-flex-center">
        <h4 class="uk-text uk-text-secondary">{{ body }}</h4>
      </div>
    }
    @if (linkMessage()) {
      <div>
        <h4>
          <a
            class="uk-link-text uk-text-primary"
            uk-icon="icon: link"
            (click)="closeLiff()"
            >{{ linkMessage() }}</a
          >
        </h4>
      </div>
    }
    @if (code()) {
      <p style="margin-top: 60%; color: #efefef">error code : {{ code() }}</p>
    }
  </div>
}
@if (showTextRedirectPort()) {
  <div>
    @if (content().header) {
      <h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary">
        {{ content().header }}
      </h2>
    }

    <div class="uk-flex uk-flex-center">
      <h4 class="uk-text uk-text-secondary">
        ระบบกำลังนำท่านไปยังหน้า Portfolio
      </h4>
    </div>
  </div>
}
@if (showTextRedirectExternal()) {
  <div>
    @if (content().header) {
      <h2 class="uk-flex uk-flex-center uk-text-bold uk-text-secondary">
        {{ content().header }}
      </h2>
    }

    <div class="uk-flex uk-flex-center">
      <h4 class="uk-text uk-text-secondary">
        ระบบกำลังนำท่านไปยังหน้าลงทะเบียน
      </h4>
    </div>
  </div>
}
